import { useMemo } from 'react';

import { useIsBreakdownMode } from './useChartIsBreakdownMode';
import { useChartState } from './useChartState';

export const useCanLoadBreakdownChart = () => {
  const chartState = useChartState();
  const isChartBreakdownMode = useIsBreakdownMode();

  return useMemo(() => {
    return (
      isChartBreakdownMode &&
      chartState.breakdown &&
      chartState.breakdown.breakdownMetric
    );
  }, [chartState, isChartBreakdownMode]);
};
